export default class CategoryDTO {
  constructor(item = {}) {
    this.id = String(item.id),
    this.name = item.name
  }
}